import { Component, EventEmitter, OnInit, Output, SimpleChanges } from '@angular/core';
import { AgentService } from 'src/app/agent/services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Router } from '@angular/router';
import * as Chart from 'chart.js';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { TabItem } from 'src/app/models/common/tab-items';

@Component({
  selector: '',
  template: '',
})
export class DashboardDataHandlerComponent extends BaseSearchComponent<AgentService> implements OnInit {
  chart: Chart;
  @Output() closeChart = new EventEmitter<string>();
  searchPremiumDueName: string;
  searchPremiumOverDueName: string;
  tabList: TabItem[];
  selectedTab: TabItem;
  quickNavigationList = [
    { labelKey: 'premiumDue', route: '/search-premium-due' },
    { labelKey: 'premiumOverDue', route: '/premium-over-due' },
    { labelKey: 'LAPSEDPOLICIES', route: '/getLapsedPolicies' },
    { labelKey: 'revivedPolicies', route: '/getrevisedPolicies' },
    { labelKey: 'upcomingTrainingAndExams', route: '/upcoming-tranings-and-exams' },
    // Add more items as needed
  ];
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, router);
    this.searchPremiumDueName = 'SearchPremiumDue';
    this.searchPremiumOverDueName = 'SearchRecruitmentStatus';
  }

  ngOnInit() {
    this.tabList = this.getTabList();
    if (this.tabList[0] != undefined) {
      this.selectedTab = this.tabList[0];
      this.tabList[0].isSelected = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  protected getTabList(): TabItem[] {
    return [
      {
        id: this.settingService.getLabelValue('premiumDue'),
        isSelected: true,
      },
      {
        id: this.settingService.getLabelValue('premiumOverDue'),
        isSelected: false,
      },
      {
        id: this.settingService.getLabelValue('upcomingTrainingAndExams'),
        isSelected: false,
      },
    ];
  }

  // dashboard.component.ts

  policyDetails = {
    Submitted: '30',
    Issued: 24,
    Revived: 5,
    Cancelled: 4,
    Lapse: 1,
    Total: 24,
  };

  premiumDetails = [
    {
      Premium: 'Collected (A)',
      Regular: 165200.0,
      Single: 12500.0,
      FYP: 165200.0,
      Renewal: 98200.0,
    },
    {
      Premium: 'Chargeback (B)',
      Regular: 3200.0,
      Single: 1500.0,
      FYP: 2200.0,
      Renewal: 800.0,
    },
    {
      Premium: 'Total (A-B)',
      Regular: 162000.0,
      Single: 11000.0,
      FYP: 163000.0,
      Renewal: 97400.0,
    },
  ];

  // Extract keys dynamically
  getPolicyKeys(): string[] {
    return Object.keys(this.policyDetails);
  }

  getPremiumKeys(): string[] {
    return this.premiumDetails.length > 0 ? Object.keys(this.premiumDetails[0]) : [];
  }

  premiumDueData = [
    {
      'Due Date': '2012-06-21',
      'Policy Id': 'A0003001',
      Name: 'Olong Cand',
      Premium: '1000.00',
    },
    {
      'Due Date': '2012-06-21',
      'Policy Id': 'A0003023',
      Name: 'Gerald Glan',
      Premium: '1500.00',
    },
    {
      'Due Date': '2012-06-21',
      'Policy Id': 'A0003031',
      Name: 'John David',
      Premium: '1200.00',
    },
    {
      'Due Date': '2012-06-21',
      'Policy Id': 'A0003042',
      Name: 'Ronald Dsouza',
      Premium: '7500.00',
    },
  ];

  premiumOverdueData = [
    {
      'Due Date': '2012-06-14',
      'Policy Id': 'A0004035',
      Name: 'Rachel Green',
      Premium: '1800.00',
      'Delay (in Days)': 7,
    },
    {
      'Due Date': '2012-06-16',
      'Policy Id': 'A0004048',
      Name: 'Chandler Bing',
      Premium: '2500.00',
      'Delay (in Days)': 5,
    },
  ];

  get overdueTableKeys(): string[] {
    return this.premiumOverdueData.length > 0 ? Object.keys(this.premiumOverdueData[0]) : [];
  }
  get tableKeys(): string[] {
    return this.premiumDueData.length > 0 ? Object.keys(this.premiumDueData[0]) : [];
  }

  isNumber(value: any): boolean {
    return typeof value === 'number' && !isNaN(value);
  }

  setTab(tab: TabItem) {
    this.selectedTab = tab;
  }
}
